import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError, Field } from 'redux-form'
import { Breadcrumb, Modal, Button } from 'semantic-ui-react'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { codeOfConductPath, homePath } from 'routes'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import VendorInfo from './VendorInfo'
import { getCOCDetail, submitCOC, getVendorEmail } from 'ducks/codeOfConduct'
import { MainBodyContent, CustomButton, StdCard, CommentRow } from 'components'
import { SCCont, SCContDetail, SubmitButton } from './VendorInfo/styled'
import { options } from '../AttributeData'

const CodeOfConductDetails = (props) => {
  const { detailCOC, handleSubmit, valueForm, userData } = props
  const [showDialogComment, setShowDialogComment] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [comment, setComment] = useState('')
  const [showReUploadForm, setShowReUploadForm] = useState(false)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    // send ID to get detail
    props.getCOCDetail(props.match.params.scId)
    props.getVendorEmail(detailCOC.vendorCode)
  }, [])

  function submitValidate() {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100)
      .then(() => {
        // validate data
        var errors = {}

        if (valueForm.status === 16) {
          if ((valueForm.attachment || []).length === 0) {
            errors.attachment = 'Required!'
          }

          if (detailCOC.status === 16) {
            if (valueForm.comment === undefined || valueForm.comment === '') {
              errors.comment = 'Required!'
            }
          }
        }

        if (valueForm.status === 17) {
          if (!valueForm.exceptedReasonCode) {
            errors.exceptedReasonCode = 'Required!'
          } else {
            if (valueForm.exceptedReasonCode === 'R005') {
              // for object data data === ''
              if (valueForm.exceptedReasonOther === undefined || valueForm.exceptedReasonOther === '' ||  valueForm.exceptedReasonOther === null) {
                errors.exceptedReasonOther = 'Required!'
              }
            }
          }
        }

        if (Object.keys(errors).length) {
          scrollToFirstValidateFailElement(errors)
          throw new SubmissionError(errors)
        } else {
          setShowConfirm(true)
        }
      })
  }

  const submitCOCData = () => {
    // data passing to submit
    let data = {
      docId: valueForm.id,
      status: valueForm.status,
      exceptedReasonCode: valueForm.exceptedReasonCode,
      exceptedReasonOther: valueForm.exceptedReasonOther,
      attachment: valueForm.attachment,
      comment: valueForm.comment || comment
    }
    // call ducks to submit data
    props.submitCOC(data, () => { props.history.push(codeOfConductPath) })
  }

  return (
    <MainBodyContent headerTitle={`Supplier Code of Conduct${detailCOC.documentNumber ? ` - ${detailCOC.documentNumber}` : ''}`}
      accessoriesHeader={<div style={{ display: 'flex' }}>
        <CustomButton
          title='View Acknowledge Form'
          icon='clipboard'
          btnColor='gray'
          onClick={() => detailCOC.urlPrintForm ? window.open(detailCOC.urlPrintForm) : null}
        />
        <CustomButton
          icon='times'
          title='Close'
          btnColor='red'
          onClick={() => props.history.push(codeOfConductPath)}
        />
      </div>}
      breadcrumbs={
        <Breadcrumb
          icon='right angle'
          sections={[
            { key: 'CodeConduct', content: 'Supplier Code of Conduct', link: true, onClick: () => props.history.push(codeOfConductPath) },
            { key: 'CodeConduct_Detail', content: detailCOC.documentNumber || 'Detail', active: true }
          ]}
        />
      }>
      <VendorInfo data={detailCOC} />
      <StdCard title='Status' fitContent={false} style={{ marginTop: '1rem' }} enableCollapse={false}>
        <SCCont>
          <SCContDetail style={{ marginTop: '0px' }} >
            <div>
              <form>
                <Field
                  name='status'
                  label=''
                  type={type.radio}
                  editable={detailCOC.status !== 16}
                  // require
                  options={options.status}
                  size='medium'
                  component={FieldInput}
                />
                {
                  valueForm.status === 17 ?
                  <React.Fragment>
                    <div style={{ display: 'flex' }}>
                      <Field
                        name='exceptedReasonCode'
                        label='Excepted Reason'
                        require
                        type={type.select}
                        placeHolder='-- Please Select Reason --'
                        options={options.exceptedReason}
                        component={FieldInput} />
                      <Field type={type.empty} component={FieldInput} />
                    </div>
                    {
                      valueForm.exceptedReasonCode === 'R005' ?
                        <div>
                          <Field
                            name='exceptedReasonOther'
                            label='โปรดระบุ / Please specify'
                            require
                            type={type.textArea}
                            component={FieldInput} />
                        </div> : null
                    }
                    <div>
                      <Field name='comment' label='Comment' type={type.textArea} component={FieldInput} />
                    </div>
                    <SubmitButton>
                      <Button
                        type='submit'
                        content='Save & Submit'
                        color='facebook'
                        floated='center'
                        style={{ width: '150px' }}
                        onClick={handleSubmit(() => submitValidate())}
                      />
                    </SubmitButton>
                  </React.Fragment> : null
                }
              </form>
              {
                detailCOC.status === 16 ?
                  <Button
                    type='button'
                    content='Upload New Acknowledge Form'
                    color='blue'
                    style={{ marginRight: '0.3125rem' }}
                    onClick={() => setShowReUploadForm(!showReUploadForm)}
                  /> : null
              }
            </div>
          </SCContDetail>
        </SCCont>
      </StdCard>
      {
        valueForm.status === 16 && detailCOC.status !== 16 ?
          <StdCard title='Action for approval' fitContent={false} style={{ marginTop: '1rem' }}>
            <SCCont>
              <form>
                <div>
                  <Field name='attachment' label='Attachment :' type={type.file} require component={FieldInput} />
                </div>
                <div>
                  <Field name='comment' label='Comment' type={type.textArea} component={FieldInput} />
                </div>
              </form>
            </SCCont>
            <SubmitButton>
              <Button
                type='submit'
                content='Save & Submit'
                color='facebook'
                floated='center'
                style={{ width: '150px' }}
                onClick={handleSubmit(() => submitValidate())}
              />
            </SubmitButton>
          </StdCard>
        : null
      }
      {
        detailCOC.status === 16 && showReUploadForm ?
          <StdCard title='Upload New Acknowledge Form' fitContent={false} enableCollapse={false} style={{ marginTop: '1rem' }}>
            <SCCont>
              <form>
                <div>
                  <Field name='attachment' label='Attachment :' type={type.file} require component={FieldInput} />
                </div>
                <div>
                  <Field name='comment' label='Comment' require type={type.textArea} component={FieldInput} />
                </div>
              </form>
            </SCCont>
            <SubmitButton>
              <Button
                type='submit'
                content='Save & Submit'
                color='facebook'
                floated='center'
                style={{ width: '150px' }}
                onClick={handleSubmit(() => submitValidate())}
              />
            </SubmitButton>
          </StdCard>
        : null
      }
      <SCCont>
        <StdCard
          title='Comment History'
          style={{ flex: 1, marginTop: '1rem' }}
          accessoriesHeader={detailCOC.status === 15 && valueForm.status === 15 ?
            <Button
              type='button'
              content='Add Comment'
              color='facebook'
              icon='plus'
              labelPosition='right'
              floated='right'
              style={{ marginRight: '0.3125rem' }}
              onClick={() => setShowDialogComment(true)}
            /> : null}
        >
          {
            (detailCOC.codeOfConductComments || []).map((item, i) => {
              let files = (detailCOC.attachments || []).filter(x => x.commentId === item.id)
              return <CommentRow data={item} files={files} />
            })
          }
        </StdCard>
      </SCCont>
      <Modal open={showDialogComment}>
        <Modal.Header>Add Comment</Modal.Header>
        <Modal.Content>
          <form>
            <Field name='comment' require label='Comment' type={type.textArea} specialOnChange={(data) => { setComment(data) }} component={FieldInput} />
          </form>
        </Modal.Content>
        <Modal.Actions style={{ textAlign: 'center' }} >
          <Button
            type='button'
            content='Add'
            color='green'
            disabled={comment === ''}
            onClick={() => submitCOCData()}
          />
          <Button
            type='button'
            content='Cancel'
            color='red'
            onClick={() => setShowDialogComment(false)}
          />
        </Modal.Actions>
      </Modal>
      <Modal open={showConfirm}>
        <Modal.Header>Are You Sure?</Modal.Header>
        <Modal.Content>
        </Modal.Content>
        <Modal.Actions style={{ textAlign: 'center' }} >
          <Button
            type='button'
            content='Save & Submit'
            color='facebook'
            onClick={() => submitCOCData()}
          />
          <Button
            type='button'
            content='Cancel'
            color='red'
            onClick={() => setShowConfirm(false)}
          />
        </Modal.Actions>
      </Modal>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  detailCOC: state.codeOfConduct.detailCOC.data,
  vendorStatus: state.codeOfConduct.vendorStatus.data,
  initialValues: {
    ...state.codeOfConduct.detailCOC.data
  },
  valueForm: getFormValues('formDetailCOC')(state) || {},
  userData: state.authen.user||{}
})

const mapDispatchToProps = {
  getCOCDetail,
  getVendorEmail,
  submitCOC
}

const cocDetailForm = reduxForm({
  form: 'formDetailCOC',
  enableReinitialize: true,
})(CodeOfConductDetails)

export default connect(mapStateToProps, mapDispatchToProps)(cocDetailForm)
